import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { LazyImage } from './LazyImage';
interface ProjectCardProps {
  title: string;
  category: string | string[];
  year: string;
  image: string;
  thumbnail?: string;
  mediaType?: 'image' | 'video';
  index: number;
  height?: string;
}
export function ProjectCard({
  title,
  category,
  year,
  image,
  thumbnail,
  mediaType = 'image',
  index,
  height = 'medium'
}: ProjectCardProps) {
  // Check if the image is a GIF
  const isGif = image.toLowerCase().includes('.gif') || image.startsWith('data:image/gif');
  // Check if this is a video with Video category
  const categories = Array.isArray(category) ? category : [category];
  const isVideoWithCategory = categories.includes('Video') && thumbnail;
  // Use thumbnail for display if it's a video with Video category
  const displayImage = isVideoWithCategory ? thumbnail : image;
  return <motion.div initial={{
    opacity: 0,
    y: 50
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay: index * 0.1
  }} className="group relative w-full cursor-pointer break-inside-avoid mb-8" data-id="element-152">
      <div className="relative overflow-hidden bg-neutral-900 rounded-sm" data-id="element-153">
        {/* Overlay - starts transparent, becomes visible on hover */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-500 z-10" data-id="element-154" />

        {/* Play Icon for videos with Video category */}
        {isVideoWithCategory && <div className="absolute inset-0 flex items-center justify-center z-20 pointer-events-none" data-id="element-155">
            <motion.div initial={{
          scale: 1
        }} whileHover={{
          scale: 1.1
        }} className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center shadow-lg" data-id="element-156">
              <Play className="w-8 h-8 text-black fill-black ml-1" data-id="element-157" />
            </motion.div>
          </div>}

        {/* Media with lazy loading */}
        {isVideoWithCategory || mediaType === 'image' ? <motion.div whileHover={isGif ? {} : {
        scale: 1.05
      }} transition={{
        duration: 0.6,
        ease: [0.33, 1, 0.68, 1]
      }} data-id="element-158">
            <LazyImage src={displayImage} alt={title} className="w-full h-auto" data-id="element-159" />
          </motion.div> : <motion.video src={image} autoPlay loop muted playsInline className="w-full h-auto" whileHover={{
        scale: 1.05
      }} transition={{
        duration: 0.6,
        ease: [0.33, 1, 0.68, 1]
      }} data-id="element-160" />}
      </div>
    </motion.div>;
}